import React from "react";
import { Col } from "react-bootstrap";
import { Expandable } from "./Expandable";
import { renderDesktop } from "../DesktopMenu";
import { _t } from "app/i18n/i18n";
import { renderMobile } from "../MobileMenu";

export const Group = ({ group, children }) => <Expandable label={_t(group)}>{children.map(renderDesktop)}</Expandable>;

export const HeadingWrapper = (props) =>
  props.noCol ? (
    <Heading {...props} />
  ) : (
    // <Col md={3} lg={true}>
    <Col>
      <Heading {...props} />
    </Col>
  );

export const Heading = ({ heading, children }) => (
  <>
    <h4>{_t(heading)}</h4>
    {children.map(renderDesktop)}
  </>
);

export const ColWrapper = ({ children, col }) => <Col {...col}>{children.map(renderDesktop)}</Col>;

export const ColWrapperMob = ({ children }) => children.map(renderMobile);
